import { generateTypes } from '../utils/HttpReducerHelper';

const OPEN_TEAMS_WIZZARD = 'platfi-ui-app/TEAMS/OPEN_TEAMS_WIZZARD';
const CLOSE_TEAMS_WIZZARD = 'platfi-ui-app/TEAMS/CLOSE_TEAMS_WIZZARD';
const WIZZARD_ADD_TEAM_SET_TEAM_NAME = 'platfi-ui-app/TEAMS/WIZZARD_ADD_TEAM_SET_TEAM_NAME';
const WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION = 'platfi-ui-app/TEAMS/WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION';
const WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS = 'platfi-ui-app/TEAMS/WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS';
const WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER =
  'platfi-ui-app/TEAMS/WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER';
const WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER =
  'platfi-ui-app/TEAMS/WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER';
const myTeamsList = generateTypes('TEAMS', 'MY_TEAMS_LIST');
const newUsers = generateTypes('USERS', 'INVITE_MORE_USERS');
const REQUEST_INVITE_COMPANY = 'platfi-ui-app/TEAMS/REQUEST_INVITE_COMPANY';
const REQUEST_ADD_TEAM = 'platfi-ui-app/TEAMS/REQUEST_ADD_TEAM';
const REQUEST_ADD_TEAM_SUCCESS = 'platfi-ui-app/TEAMS/REQUEST_ADD_TEAM_SUCCESS';
const REQUEST_INVITE_MORE_MEMBERS = 'platfi-ui-app/TEAMS/REQUEST_INVITE_MORE_MEMBERS';

export * from './moveTeamMembers/types';

export {
  OPEN_TEAMS_WIZZARD,
  CLOSE_TEAMS_WIZZARD,
  WIZZARD_ADD_TEAM_SET_TEAM_NAME,
  WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION,
  WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS,
  WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER,
  WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER,
  myTeamsList,
  newUsers,
  REQUEST_INVITE_COMPANY,
  REQUEST_ADD_TEAM,
  REQUEST_ADD_TEAM_SUCCESS,
  REQUEST_INVITE_MORE_MEMBERS,
};
